import { createTheme } from '@mui/material/styles';

// Desiree African Hair Braiding theme - Red, Gold & Black
const theme = createTheme({
  palette: {
    primary: {
      main: '#C41E3A', // Red from logo
      light: '#E53E5C',
      dark: '#9A1830',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#B8A04A', // Gold from logo
      light: '#D4BC6A',
      dark: '#8A7838',
      contrastText: '#000000',
    },
    background: {
      default: '#FFFFFF', // White
      paper: '#FFFFFF',
    },
    text: {
      primary: '#1A1A1A', // Near black
      secondary: '#4A4A4A', // Dark gray
    },
    error: {
      main: '#D32F2F',
    },
    warning: {
      main: '#B8A04A', // Gold
    },
    info: {
      main: '#1976D2',
    },
    success: {
      main: '#388E3C',
    },
  },
  typography: {
    fontFamily: '"Poppins", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 600,
      fontSize: '2.5rem',
    },
    h2: {
      fontWeight: 600,
      fontSize: '2rem',
    },
    h3: {
      fontWeight: 500,
      fontSize: '1.75rem',
    },
    h4: {
      fontWeight: 500,
      fontSize: '1.5rem',
    },
    h5: {
      fontWeight: 500,
      fontSize: '1.25rem',
    },
    h6: {
      fontWeight: 500,
      fontSize: '1rem',
    },
    button: {
      textTransform: 'none',
      fontWeight: 500,
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
          },
        },
        contained: {
          color: '#FFFFFF',
          '&:hover': {
            boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.15)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.05)',
          borderRadius: 12,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: '#E0E0E0',
            },
            '&:hover fieldset': {
              borderColor: '#C41E3A',
            },
          },
        },
      },
    },
  },
});

export default theme;
